var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    className: "langIcon",
    id: "france",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M37 10a4 4 0 0 0-4-4h-8v26h8a4 4 0 0 0 4-4V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#269",
    d: "M5 32a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h8v26H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M25 6H13v26h12V6Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.55ca1e3abb89f2518b8963bf0c069c30.svg";
export { ForwardRef as ReactComponent };